module.exports = false;


//////////////////
// WEBPACK FOOTER
// /Users/alexandre/Documents/web/riberfuso/resources/ng/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 5